// @ts-check
import {
  buildCalendarVisitSchedule,
  createCalendarVisitSchedule
} from '../calendarVisitSchedule.schema';
import { checkCooperative } from './checkCooperative';
import { checkLinkWithPadPrescription } from './checkLinkWithPadPrescription';
import { checkSuspensionVisit } from './checkSuspensionVisit';
/**
 * @typedef {import('./transformPadPrescriptionsToPrescriptionLoadSchedule').PadVisit} PadVisit
 * @typedef {import('../calendarVisitSchedule.schema').CalendarVisitSchedule} CalendarVisitSchedule
 */

/**
 * Transforms a single padVisit into a genericVisit structure.
 * Handles PadVisit objects, empty objects, or null values gracefully.
 * Pure function with no side effects.
 * @param {PadVisit} padVisit - The pad visit data (object, empty object, or null).
 * @returns {CalendarVisitSchedule | []} Transformed schedule.
 */
export const transformPadVisitToCalendarVisitScheduleCooperative = padVisit => {
  if (!shouldIncludeAsCalendarVisitScheduleCooperative(padVisit)) return [];

  return createCalendarVisitSchedule(buildCalendarVisitSchedule(padVisit));
};

/**
 * Determines whether a pad visit should be included in the cooperative schedule.
 *
 * The padVisit parameter may be a PadVisit object, an empty plain object, or null.
 *
 * @param {PadVisit} padVisit - The pad visit data.
 * @returns {boolean} True if the visit should be included, otherwise false.
 */
const shouldIncludeAsCalendarVisitScheduleCooperative = padVisit => {
  if (!padVisit) return false;
  const isCooperative = checkCooperative(padVisit);
  const isSuspensionVisit = checkSuspensionVisit(padVisit);
  const hasLinkWithPadPrescription = checkLinkWithPadPrescription(padVisit);

  return isCooperative && !isSuspensionVisit && !hasLinkWithPadPrescription;
};
